import React, { useState, useEffect } from 'react';
import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { clrs } from "../../../../constants/colors";

const PercentageArea = ({trends}) => {
    const {t} = useTranslation();

    const emissionMapping = {
        "CO_gs": "emission.CO_gs",
        "CO_mgm3": "emission.CO_mgm3",
        "DUST": "emission.DUST",
        "FLOW": "emission.FLOW",
        "HUMIDITY": "emission.HUMIDITY",
        "NO_gs": "emission.NO_gs",
        "NO_mgm3": "emission.NO_mgm3",
        "NO2_gs": "emission.NO2_gs",
        "NO2_mgm3": "emission.NO2_mgm3",
        "NOx_gs": "emission.NOx_gs",
        "NOx_mgm3": "emission.NOx_mgm3",
        "O2": "emission.O2",
        "PT": "emission.PT",
        "SO2_gs": "emission.SO2_gs",
        "SO2_mgm3": "emission.SO2_mgm3",
        "TEMP": "emission.TEMP"
    };

    const [chartData, setChartData] = useState([]);

    function prepareChartData(data) {
        let seriesMap = {};

        data.forEach(item => {
            if (!seriesMap[item.name]) {
                seriesMap[item.name] = [];
            }
            seriesMap[item.name].push([Date.parse(item.timestamp + 'Z'), +item.value.toFixed(2)])
        });

        return Object.keys(seriesMap).map(name => {
            return {
                name: t(emissionMapping[name]),
                data: seriesMap[name]
            };
        });
    }

    useEffect(() => {
        setChartData(prepareChartData(trends))
    }, [trends]);

    const options = {
        chart: {
            type: 'area',
            height: 500,
        },
        title: {
            text: t('dataPage.analytics.emissions')
        },
        global: {
            useUTC: false
        },
        xAxis: {
            type: 'datetime',
            title: {
                text: t('dataPage.analytics.date')
            }
        },
        yAxis: {
            labels: {
                format: '{value}%'
            },
            title: {
                enabled: false
            }
        },
        tooltip: {
            headerFormat: '<b>{series.name}</b><br>',
            pointFormat: '{point.x:%e %b}: {point.y:.2f}'
        },
        plotOptions: {
            area: {
                stacking: 'percent',
                marker: {
                    enabled: false
                }
            }
        },
        series: chartData
    };

    Highcharts.setOptions({
        lang: {
            months: [
                t('dataPage.analytics.months.1'),
                t('dataPage.analytics.months.2'),
                t('dataPage.analytics.months.3'),
                t('dataPage.analytics.months.4'),
                t('dataPage.analytics.months.5'),
                t('dataPage.analytics.months.6'),
                t('dataPage.analytics.months.7'),
                t('dataPage.analytics.months.8'),
                t('dataPage.analytics.months.9'),
                t('dataPage.analytics.months.10'),
                t('dataPage.analytics.months.11'),
                t('dataPage.analytics.months.12')
            ],
            shortMonths: [
                t('dataPage.analytics.months.1.short'),
                t('dataPage.analytics.months.2.short'),
                t('dataPage.analytics.months.3.short'),
                t('dataPage.analytics.months.4.short'),
                t('dataPage.analytics.months.5.short'),
                t('dataPage.analytics.months.6.short'),
                t('dataPage.analytics.months.7.short'),
                t('dataPage.analytics.months.8.short'),
                t('dataPage.analytics.months.9.short'),
                t('dataPage.analytics.months.10.short'),
                t('dataPage.analytics.months.11.short'),
                t('dataPage.analytics.months.12.short')
            ]
        }
    });

    return (
        <Flex style={{width: "100%", position: "relative"}}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                containerProps={{style: {
                        width: "100%",
                        borderRadius: "10px",
                        minHeight: 300,
                        maxHeight: 1000,
                        borderBottom: `3px solid ${clrs.whiterBlacker}`,
                    }}}
            />
            <div style={{
                backgroundColor: "white",
                width: 150,
                height: "1rem",
                position: "absolute",
                bottom: 3,
                right: 3,
                borderRadius: 10
            }}></div>
        </Flex>
    );
}

export default PercentageArea;